import En from "./En";
import En2 from "./En2";

import Fr from "./Fr";

const Dict = {
  en: {
    ...En,
    ...En2
  },
  fr: {
    ...Fr
  }
};

export default Dict;
